import { render, staticRenderFns } from "./DisbursementPendingActionSection.vue?vue&type=template&id=64e8479d&scoped=true&"
import script from "./DisbursementPendingActionSection.vue?vue&type=script&lang=js&"
export * from "./DisbursementPendingActionSection.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementPendingActionSection.vue?vue&type=style&index=0&id=64e8479d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8479d",
  null
  
)

export default component.exports